const toPlain = (data) => {
    if (data == null) return data;
    if (typeof data.asMutable === 'function') return data.asMutable({ deep: true });
    if (typeof data.toJS === 'function') return data.toJS();
    return data;
};

export const resolveSystemBankId = (systemBank) => {
    const plain = toPlain(systemBank);
    if (!plain) return null;

    const nested = plain.systemBank ?? plain.bank ?? plain;
    const nestedPlain = toPlain(nested);

    return nestedPlain?.id ?? plain.systemBankId ?? plain.bankId ?? null;
};

export const resolveLinkedSystemBank = (linkedBank) => {
    const plain = toPlain(linkedBank);
    const bank = plain?.systemBank ?? plain?.bank ?? plain;
    const bankPlain = toPlain(bank);

    if (!bankPlain) {
        return null;
    }

    const id = bankPlain.id ?? plain?.systemBankId ?? plain?.bankId;
    return id != null ? { ...bankPlain, id } : bankPlain;
};

export const buildMomoPaymentFormData = ({ systemBank, identifier, amount }) => {
    const plainBank = toPlain(systemBank);
    const nested = plainBank?.systemBank ?? plainBank?.bank ?? plainBank;
    const nestedPlain = toPlain(nested);
    const systemBankId = resolveSystemBankId(systemBank);
    const normalizedAmount = amount != null && amount !== '' ? Number(amount) : null;

    const systemBankPayload = systemBankId != null
        ? { ...nestedPlain, id: systemBankId }
        : nestedPlain;

    return {
        systemBank: systemBankPayload,
        identifier: `${identifier ?? ''}`.trim(),
        amount: normalizedAmount != null && !Number.isNaN(normalizedAmount) ? normalizedAmount : null,
    };
};

export const isInvalidMomoAccountResponse = (response) => {
    const status = response?.status;
    return status === 400 || status === 422 || status === 404;
};
